// import * as apis from '@apis'

const myWorkload = {
  namespaced: true,
  state: {
    column: {},
    time: [],
    ch: {}
  },
  getters: {},
  mutations: {
  },
  actions: {
    setColumn ({state}, column) {
      state.column = column
    },
    setTime ({state}, time) {
      state.time = time
    },
    setCh ({state}, ch) {
      if (typeof ch === 'object') state.ch = ch
    }
  }
}

export default myWorkload
